module.exports = __webpack_public_path__ + "static/media/ng.f06a1a96.svg";